import type { Locale } from '@alola/contracts';
import type { Namespace, ResourceTree } from './resources';

export type LocaleBundle = Record<Namespace, ResourceTree>;

/**
 * One language's translations, loaded on demand. Each language becomes its own chunk in the web
 * build, so the entry chunk carries neither and a session downloads only the languages it shows
 * (the bundle budget). `resources` keeps both for the key checks and the tests.
 */
export async function loadLocaleBundle(locale: Locale): Promise<LocaleBundle> {
  if (locale === 'ar') {
    const [common, errors] = await Promise.all([
      import('./locales/ar/common.json'),
      import('./locales/ar/errors.json'),
    ]);
    return { common: common.default, errors: errors.default };
  }
  const [common, errors] = await Promise.all([
    import('./locales/en/common.json'),
    import('./locales/en/errors.json'),
  ]);
  return { common: common.default, errors: errors.default };
}
